// extracted by mini-css-extract-plugin
export default {"item":"answer-row-item_item__OV32j","answered":"answer-row-item_answered__XMkTI","row-field":"answer-row-item_row-field__6JXAw"};